import { getProps } from '../props';

export default () => () => getProps().onClose()